import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './error.css';

const CookiePolicy: React.FC = () => {
    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
            <div className="text-center">
                <h1 className="display-4">Cookie Policy</h1>
                <p className="lead">Our Website uses essential cookies to function properly and provide requested services. Blocking them may affect site functionality. These Cookies do not store personal data.</p>
            </div>
        </div>
    );
};

export default CookiePolicy;
